import React from "react";
import { AlertCircle, RefreshCw, Sparkles } from "lucide-react";

import Navbar from "../../../Components/Common/navbar";
import MobileViewContainer from "../../../Components/MobileViewContainer";
import { eventService } from "../../../api/services/event.service";
import CardSection from "../../Ticket/CardSection";

const DEFAULT_INFO = {
  name: "어메이징패스",
  detail: "어메이징패스는 어메이징캠프에서 사용할 수 있는 티켓입니다.",
  images: [],
};

function getErrorMessage(error) {
  if (!error) {
    return "정보를 불러오지 못했습니다.";
  }

  if (typeof error === "string") {
    return error;
  }

  return error?.response?.data?.error || error?.response?.data?.detail || error?.message || "정보를 불러오지 못했습니다.";
}

export default function AmazingPassPage() {
  const [infoData, setInfoData] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  const fetchData = React.useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await eventService.getAmazingPassInfo();
      setInfoData(response?.data?.data || null);
    } catch (e) {
      console.log(e);
      setInfoData(null);
      setError(e);
    } finally {
      setIsLoading(false);
    }
  }, []);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  const pageInfo = infoData || DEFAULT_INFO;
  const imageItems = Array.isArray(pageInfo.images) ? pageInfo.images : [];

  return (
    <MobileViewContainer>
      <Navbar />
      <div className="min-h-screen bg-[#f5f0e8] px-4 pt-8 pb-12">
        <div className="mx-auto flex w-full max-w-[640px] flex-col gap-6">
          <section className="rounded-[24px] border border-[#eddcc7] bg-white px-6 py-8 text-center shadow-[0_10px_24px_rgba(31,45,61,0.08)]">
            <div
              className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full text-white"
              style={{ background: "linear-gradient(135deg, #ff8a3d 0%, #ff4b5b 100%)" }}
            >
              <Sparkles size={30} />
            </div>

            <h1 className="text-[32px] font-semibold leading-tight text-[#152037] sm:text-[38px]" style={{ fontFamily: "Gmarket-M" }}>
              {pageInfo.name || DEFAULT_INFO.name}
            </h1>

            <p className="mt-4 text-[18px] leading-snug text-[#5f6a7c]" style={{ fontFamily: "Gmarket-M" }}>
              {pageInfo.detail || DEFAULT_INFO.detail}
            </p>
          </section>

          {isLoading ? (
            <section className="rounded-[24px] border border-[#eddcc7] bg-white px-6 py-14 text-center text-[20px] text-[#5f6a7c]" style={{ fontFamily: "Gmarket-M" }}>
              로딩중...
            </section>
          ) : error ? (
            <section className="rounded-[24px] border border-[#eddcc7] bg-white px-6 py-10 text-center">
              <div className="mb-4 flex justify-center text-[#ff8b00]">
                <AlertCircle size={34} />
              </div>
              <p className="text-[18px] leading-relaxed text-[#5f6a7c]" style={{ fontFamily: "Gmarket-M" }}>
                {getErrorMessage(error)}
              </p>
              <button
                type="button"
                className="mx-auto mt-6 flex items-center gap-2 rounded-[16px] px-5 py-3 text-[16px] text-white"
                style={{ fontFamily: "Gmarket-B", background: "linear-gradient(135deg, #ff7800 0%, #ff2d57 100%)" }}
                onClick={fetchData}
              >
                <RefreshCw size={18} />
                다시 시도하기
              </button>
            </section>
          ) : imageItems.length ? (
            <section className="overflow-hidden rounded-[24px] border border-[#eddcc7] bg-white shadow-[0_10px_24px_rgba(31,45,61,0.08)]">
              {imageItems.map((item, index) => (
                <img
                  key={`${item?.src || "amazing-pass"}-${index}`}
                  src={item?.src}
                  alt={`${pageInfo.name || DEFAULT_INFO.name} 안내 이미지 ${index + 1}`}
                  className="w-full"
                  loading="lazy"
                />
              ))}
            </section>
          ) : (
            <section className="rounded-[24px] border border-[#eddcc7] bg-white px-6 py-12 text-center text-[18px] text-[#5f6a7c]" style={{ fontFamily: "Gmarket-M" }}>
              안내 이미지 정보가 없습니다.
            </section>
          )}

          <section className="rounded-[24px] border border-[#eddcc7] bg-white px-4 py-6 shadow-[0_10px_24px_rgba(31,45,61,0.08)] sm:px-6">
            <div className="mb-4">
              <h2 className="text-[24px] font-semibold text-[#152037]" style={{ fontFamily: "Gmarket-M" }}>
                지금 바로 이용해 보세요
              </h2>
              <p className="mt-2 text-[16px] text-[#5f6a7c]" style={{ fontFamily: "Gmarket-M" }}>
                어메이징패스 구매 및 이용은 아래 메뉴에서 진행할 수 있습니다.
              </p>
            </div>

            <CardSection amazingpass={true} />
          </section>
        </div>
      </div>
    </MobileViewContainer>
  );
}
